import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * A plan's song suggestions were a page of their own; they are part of the
 * plan's sermon hub now (its Sermon page, `SermonHub`). Old links land there.
 */
export const Route = createFileRoute('/_authed/_shell/services/plans/$id_/suggestions')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/services/plans/$id/sermon', params: { id: params.id }, replace: true })
  },
})
